import axios from 'axios'

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})

export const setAuthToken = (token: string | null) => {
  if (token && token !== 'undefined' && token !== 'null') {
    apiClient.defaults.headers.common['Authorization'] = `Token ${token}`
  } else {
    delete apiClient.defaults.headers.common['Authorization']
  }
}

// 401エラー（認証失敗）時のインターセプター
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      console.warn('Unauthorized (401) error detected. Clearing token and reloading...')
      // トークンをクリア
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      setAuthToken(null)

      // 認証エラー時はページをリロードして、再ログイン（ゲストログイン）を促す
      // 無限ループを防ぐため、現在のパスがログインページなどでないか確認しても良いが
      // 今回はゲストログイン前提なので、単純にリロードしてApp.vueの初期化処理に任せる
      window.location.reload()
    }
    return Promise.reject(error)
  }
)

export const createRoom = (name: string, max_players: number, host_name?: string, is_private?: boolean, room_type: string = 'zoom_out') => {
  return apiClient.post('/rooms/', { name, max_players, host_name, is_private, room_type }).then(res => res.data)
}

export const fetchRoomList = () => {
  return apiClient.get('/rooms/').then(res => res.data)
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const updateRoom = (roomId: string, data: any) => {
  return apiClient.patch(`/rooms/${roomId}/`, data).then(res => res.data)
}

export const joinRoom = (roomId: string, player_name?: string) => {
  return apiClient.post(`/rooms/${roomId}/join/`, { player_name }).then(res => res.data)
}

export const joinRoomByInviteCode = (invite_code: string) => {
  return apiClient.post('/rooms/join_by_invite_code/', { invite_code }).then(res => res.data)
}

export const fetchRoomDetail = (roomId: string) => {
  return apiClient.get(`/rooms/${roomId}/`).then(res => res.data)
}

export default apiClient
